import { useFormContext, useController, UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PassengersType, FormType } from '../../../shared/models/form';
import MenuItem from './MenuItem';

interface PassengersControllerProps {
  fieldName: PassengersType;
  rules: UseControllerProps<FormType, PassengersType>['rules'];
  append?: () => void;
  remove?: () => void;
}

const PassengersController = ({ fieldName, rules, append, remove }: PassengersControllerProps) => {
  const { control, trigger } = useFormContext<FormType>();
  const { t } = useTranslation();
  const {
    field: { onChange, onBlur, value, ref, name },
    fieldState: { error },
  } = useController({ control, name: fieldName, rules });

  const clickHandler = (buttonValue: number, cb?: () => void) => {
    onChange(value + buttonValue);
    void trigger(['adults', 'children', 'infants']);
    if (cb) {
      cb();
    }
  };

  return (
    <MenuItem
      text={t(name)}
      value={value}
      minusButtonDisabled={error?.message?.includes('min')}
      plusButtonDisabled={error?.message?.includes('max')}
      onMinusClick={() => clickHandler(-1, remove)}
      onPlusClick={() => clickHandler(+1, append)}
      onBlur={onBlur}
      buttonName={name}
      ref={ref}
    />
  );
};

export default PassengersController;
